const productionApiUrl = "https://thecryptohub.com/backend";

export const SERVERURL = (
  process.env.REACT_APP_API_BASE_URL || productionApiUrl
).replace(/\/$/, "");
